import React from 'react';
import PropTypes from 'prop-types';

export default function registeredComponentOrChildren(Component) {
    class RegisteredComponent extends React.Component {
        componentWillMount() {
            this.props.register();
        }

        componentWillUnmount() {
            this.props.unregister();
        }

        render() {
            if (this.props.isActive()) {
                return <Component {...this.props}>{this.props.children}</Component>;
            } else {
                return this.props.children || null;
            }
        }
    }

    RegisteredComponent.propTypes = {
        isActive: PropTypes.func.isRequired,
        dismiss: PropTypes.func.isRequired,
        register: PropTypes.func.isRequired,
        unregister: PropTypes.func.isRequired,
        children: PropTypes.node,
    };

    return RegisteredComponent;
}



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/registeredComponentOrChildren.js